import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  title: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    '& .myev-MuiTypography-h3': { textTransform: 'inherit' },
  },
  evArrow: {
    fontSize: 10,
  },
  evLink: {
    fontSize: 12,
  },
  contentText: {
    fontSize: '16px',
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(6.9),
  },
  button: {
    fontSize: '16px',
    marginLeft: theme.spacing(0),
    marginRight: theme.spacing(3),
    marginBottom: theme.spacing(3),
    backgroundColor: '#007CAD',
    '& .myev-MuiButton-label': { color: 'rgba(255, 255, 255, 1)' },
  },
  detailButton: {
    width: '-webkit-fill-available',
    boxShadow: '0px 0px 0px 0px',
    borderStyle: 'groove',
    borderWidth: '1px',
    backgroundColor: '#FFFFFF',
    borderColor: theme.evPalette.ocean[600],
    color: theme.evPalette.ocean[600],
    '&:hover': {
      color: theme.palette.common.white,
      backgroundColor: theme.evPalette.ocean[600],
    },
  },
  statusCompleted: {
    backgroundColor: '#E2F7DA',
    '& .myev-MuiChip-label': { color: '#1F6800', fontWeight: 'bold' },
  },
  statusInProcess: {
    backgroundColor: '#FFECB7',
    '& .myev-MuiChip-label': { color: '#B56114', fontWeight: 'bold' },
  },
  statusCreated: {
    backgroundColor: '#FFECB7',
    '& .myev-MuiChip-label': { color: '#B56114', fontWeight: 'bold' },
  },
  addressTooltipColor: {
    backgroundColor: '#4D5365',
    margin: theme.spacing(0),
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    '& .myev-MuiChip-labelSmall': { color: 'white', fontWeight: 'bold' },
  },
  evDialogContentText: {
    '& .myev-makeStyles-contentText-75': { marginBottom: 0 },
  },
  evArrowDropDown: {
    borderLeft: '1px solid #007CAD',
  },
  tableDataRow: {
    '& .myev-makeStyles-rowColor-*': { backgroundColor: 'white' },
    background: theme.evPalette.charcoal[100],
    '& .myev-MuiTableCell-body': { color: '#1B202C' },
  },
  actionsCell: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  closeButton: {
    position: 'absolute',
    right: '30px',
  },
  dialogContentContainer: {
    padding: '0px 24px',
  },
}));
